import React from 'react';
import MiscellanyOrderResumeProperties from "./MiscellanyOrderResumeProperties";
import {Observer} from "mobx-react-lite";
import ShowInvoiceAdditionalPrices from '../../../Info/ShowInvoiceAdditionalPrices/ShowInvoiceAdditionalPrices';
import ShowClientToContactInfo from '../../../Info/ShowClientToContactInfo/ShowClientToContactInfo';
import PaymentsTable from '../../../Info/PaymentsTable/PaymentsTable';
import { useStyles } from './MiscellanyOrderResume.style';
import OrderAdditionalPrice from '../../../../entities/OrderAdditionalPriceRequest';
import Alert from '../../../../ui_components/Alert/Alert';
import { useI18nContext } from '../../../../contexts/I18nContext';
import AlertType from '../../../../ui_components/Alert/AlertType';

const MiscellanyOrderResume: React.FC<MiscellanyOrderResumeProperties> = ({
                                                                    store
                                                                }) => {

    const classes = useStyles();
    const i18n = useI18nContext();

    return <Observer>
        {() => (
            <div className={classes.container}>
                {store.selectedClient && <ShowClientToContactInfo
                    client={store.selectedClient}/>}

                {store.additionalPrices.length > 0 &&
                    <ShowInvoiceAdditionalPrices additionalPrices={store.additionalPrices.map((p) => {
                        return new OrderAdditionalPrice(p.amount, p.comment, p.isPercentage)
                    })}></ShowInvoiceAdditionalPrices>}

                {store.payments.length > 0 &&
                    <PaymentsTable payments={store.payments}/>}

                <div className={classes.alert}>
                    <Alert
                        className={classes.alert}
                        text={i18n.translate(store.validationgErrorKey)}
                        type={AlertType.DANGER}
                    />
                </div>
                
            </div>
        )}
    </Observer>
}

export default MiscellanyOrderResume;
